import { render, staticRenderFns } from "./CreateMessageCategory.vue?vue&type=template&id=40725c7b&"
import script from "./CreateMessageCategory.vue?vue&type=script&lang=js&"
export * from "./CreateMessageCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports